import Option from '@/components/form/types/Option.ts';

export enum ParticipantLimitMode {
  PER_TOUR_OPTION = 'PER_TOUR_OPTION',
  PER_VARIANT = 'PER_VARIANT',
  NONE = 'NONE',
}

export const ParticipantLimitMode_NONE = {
  value: ParticipantLimitMode.NONE,
  label: 'Brak limitu',
};

export const ParticipantLimitMode_PER_TOUR_OPTION = {
  value: ParticipantLimitMode.PER_TOUR_OPTION,
  label: 'Per cała opcja dodatkowa',
};

export const ParticipantLimitMode_PER_VARIANT = {
  value: ParticipantLimitMode.PER_VARIANT,
  label: 'Per wariant',
};

export const participantLimitModesForTourOption: Option[] = [
  ParticipantLimitMode_NONE,
  ParticipantLimitMode_PER_TOUR_OPTION,
];

export const participantLimitModesForVariant: Option[] = [
  ParticipantLimitMode_NONE,
  ParticipantLimitMode_PER_VARIANT,
];

export const participantLimitModesForTourOptionWithAge: Option[] = [
  ParticipantLimitMode_NONE,
  ParticipantLimitMode_PER_TOUR_OPTION,
];
